<template>
<div :class="'apps dirr ' + $store.state.direction" v-if="$i18n.locale=='ar'">
    <v-container>
        <div class="panl-title mx-3">
                <img :src="$vuetify.theme.dark ? '/assets/img/z-mohammed_dark.svg' : '/assets/img/z-mohammed.svg'" />
                <a >
                    <div class="tl panl-title-text d-inline"> تطبيقات الجوال </div>
                </a>
            </div>
        <v-row no-gutters>
            <v-col cols="12" sm="6" xs="12" md="3" lg="3" class="appsMenu" v-if="apps_skeleton">
                <v-skeleton-loader  class="mx-auto" max-width="300" type="table-cell@5"></v-skeleton-loader>
                <v-skeleton-loader  class="mx-auto" max-width="300" type="table-cell@5"></v-skeleton-loader>
            </v-col>
            <v-col cols="12" sm="6" xs="12" md="3" lg="3" class="appsMenu" v-else>
                
                <div class="appsList">
                    <div class="app" v-for="(item, index) in appres" :key="index">
                    <img v-if="item.pic2" @click="DefApp(item.id)" :src="`https://alkafeel.net/alkafeel_back_test/img/apps/${item.pic2}`" :alt="`Image ${index + 1}`" class="filter">
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="6" xs="12" md="5" lg="6" class="appDesc" v-if="loading">
                <v-skeleton-loader  class="mx-auto" max-width="100%" type="paragraph, sentences, paragraph, sentences, actions"></v-skeleton-loader>
            </v-col>
            <v-col cols="12" sm="6" xs="12" md="5" lg="8" class="appDesc" v-else>
                <p class="tl">{{DefAppres.title}}</p>
                <p class="tx">{{DefAppres.description}}</p>
                <div class="stores">
                    <a :href="DefAppres.google" target="_blank" class="playStore" v-if="DefAppres.google">
                        <img src="/assets/img/apps/google-play.svg" class="filter" />
                    </a>
                    <span></span>
                    <a :href="DefAppres.apple" target="_blank" class="appStore" v-if="DefAppres.apple">
                        <img src="/assets/img/apps/app-store.svg" class="filter"/>
                    </a>
                </div>
            </v-col>
            <!-- <v-col cols="12" sm="6" xs="12" md="3" lg="3" class="appImg d-none d-sm-none d-md-flex" v-if="loading">
                <v-skeleton-loader class="mx-auto" width="350" min-width="350" max-width="350" type="image"></v-skeleton-loader>
            </v-col>
            <v-col cols="12" sm="6" xs="12" md="3" lg="3" class="appImg d-none d-sm-none d-md-flex" v-else>
                <div class="img_con">
                    <div class="cover"></div>
                    <img :src="resUrl+'img/apps/'+DefAppres.sec_pic" alt="">
                </div>
            </v-col> -->
        </v-row>
    </v-container>
</div>
</template>


<script>

export default {
    name: 'Apps',
    data() {
        return {

            appres:[],
            DefAppres:[],
            apps_skeleton:true,
            loading: true
        }
    },
    components: {

    },
    directives: {

    },
    computed: {
    },
    mounted() {
        
    },
    created () {
        this.initialize();
        this. DefApp(1);
    },
    methods:{
        initialize() {
            this.$axios.get("apps/all", {
            })
            .then(res => {
                this.apps_skeleton = false;
                this.appres = res.data.Data;
                
            })
        },
        DefApp(i) {
            this.$axios.get("apps/ById/"+i, {
            })
            .then(res => {
                this.loading = false;
                this.DefAppres = res.data.Data;
            })
        },
    }
}
</script> 

<style scoped>
.apps {
    background-image: none !important;
}

</style>